module.exports = __webpack_public_path__ + "static/OneClickConnection-f2efc6e12d8900583be134b0e5aa5245.png";